import { render, staticRenderFns } from "./empty-result.vue?vue&type=template&id=e50112d8&scoped=true"
import script from "./empty-result.vue?vue&type=script&lang=js"
export * from "./empty-result.vue?vue&type=script&lang=js"
import style0 from "./empty-result.vue?vue&type=style&index=0&id=e50112d8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e50112d8",
  null
  
)

export default component.exports